import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { login } from "../../services/authService";
import { AUTH_STATUS } from "../../utils/authUtils";

import "./Login.css";
import useAuth from "../../context/AuthContext";

const Login = () => {
  const navigate = useNavigate();
  const { status } = useAuth();

  useEffect(() => {
    const { LOADING, UNAUTHENTICATED, AUTHENTICATED } = AUTH_STATUS;

    if (status !== LOADING && status === UNAUTHENTICATED) {
      login();
    } else if (status === AUTHENTICATED) {
      navigate("/dashboard");
    }
  }, [navigate, status]);

  return (
    <div>
      <div className="center">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Login;
